/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in localStorage */
  static #STORAGE_KEY = "viewedProducts";
  /** @static @constant {string} Legacy key used by the product-page recently viewed section */
  static #LEGACY_STORAGE_KEY = "recently_viewed_products";
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 20;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    const normalizedId = String(productId);
    if (!normalizedId) return;

    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter(
      (/** @type {string} */ id) => id !== normalizedId,
    );
    viewedProducts.unshift(normalizedId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
    localStorage.removeItem(this.#LEGACY_STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from localStorage.
   * @returns {string[]} The list of viewed products, most recent first.
   */
  static getProducts() {
    const stored = this.#read(this.#STORAGE_KEY);
    const legacy = this.#read(this.#LEGACY_STORAGE_KEY);
    const merged = [];
    const seen = new Set();

    for (const id of [...stored, ...legacy]) {
      const value = String(id);
      if (!value || seen.has(value)) continue;
      seen.add(value);
      merged.push(value);
    }

    return merged;
  }

  /**
   * @param {string} key
   * @returns {unknown[]}
   */
  static #read(key) {
    try {
      const parsed = JSON.parse(localStorage.getItem(key) || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
}
